var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function StepWelcome(_a) {
    var onNext = _a.onNext;
    return (_jsxs("div", __assign({ className: "box-welcome" }, { children: [_jsx("h2", { children: "Seja bem-vindo(a) \u00E0 comunidade " }), _jsx("h1", { children: "CeletiHub!" }), _jsx("p", { children: "Aqui voc\u00EA faz parte de uma rede de provedores que cresce e se conecta todos os dias. Vamos configurar seu acesso em instantes." }), _jsx("div", __assign({ className: "box-first-access-button" }, { children: _jsx("button", __assign({ className: "btn-first-access", onClick: onNext }, { children: "Come\u00E7ar" })) }))] })));
}
export default StepWelcome;
